import { Outlet } from 'react-router-dom';

import { ContentProvider } from '../store';

/**
 * The seven website screens share one store, so they share one route element.
 *
 * The provider has to sit above the routes rather than inside each screen: a draft saved on the
 * news screen has to still be there after a visit to Media, and a provider per screen would reset
 * it on every tab change. It is the same shape the admin section's areas use (`AdminPeopleArea`),
 * so the zone's route module stays a list of addresses and nothing else.
 *
 * State lives here and nowhere else — not in local storage, not on a server. Leaving the Team
 * Portal and coming back puts the fixtures back, which is the honest behaviour for a module with
 * no backend and the one the demo follows too.
 */
export function ContentArea() {
  return (
    <ContentProvider>
      <Outlet />
    </ContentProvider>
  );
}
